import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faRoute} from '@fortawesome/free-solid-svg-icons'

import './csvbutton.css'

export default class TrendButton extends Component {

  render() {
    const callback = this.props.onClick ?? (()=>{});
    return (
      <span className="csvbutton-dot" onClick={callback}>
        <FontAwesomeIcon className="icon-nudge" icon={faRoute} color="#257461" />
      </span>  
    )
  }
}
